import dateFormat from "dateformat";
import { formatDateTH_full2 } from "../../utilities/DateUtil";
import { generatePdf } from "../../utilities/PDFMakeUtil";

//EXCEL
import * as FileSaver from 'file-saver';
import XLSX from 'tempa-xlsx';
import { strToArrBuffer, excelSheetFromDataSet } from "../../utilities/dataHelpers";

export const pdfRPT218 = ({dataReport, setLoading, setDialogPDF}) => {

    const header = () => {
        const styleFont = { alignment: "center", fontSize: 12 };

        const header = [
            {
                c1: "ที่",
                c2: "รายการ",
                c3: "หน่วย",
                c4: "ราคาต่อหน่วย",
                c5: "สัญญา",
                c6: "จอง",
                c7: "เบิก",
                c8: "ค้างคืน",
            },
           
        ];

        let resultobj = [];
        header.map((prop, index) => {
            // console.log(prop);
            let result = [];
            if (index === 0) {
                result = [
                    { text: prop.c1, style: styleFont },
                    { text: prop.c2, style: styleFont },
                    { text: prop.c3, style: styleFont },
                    { text: prop.c4, style: styleFont },
                    { text: prop.c5, style: styleFont },
                    { text: prop.c6, style: styleFont },
                    { text: prop.c7, style: styleFont },
                    { text: prop.c8, style: styleFont },
                ];
            } else {
                result = Object.keys(prop).map((d, i) => ({ text: prop[d], style: styleFont }));
            }
            resultobj.push(result);
        });

        return [
            {
                text: "รายงานการเบิกวัสดุ/อุปกรณ์",
                style: { alignment: "center", fontSize: 14, bold: true },
            },
            {
                columns: [
                    {
                        table: {
                            widths: ["5%", "35%", "10%", "10%", "10%", "10%", "10%", "10%"],
                            body: resultobj,
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return 0.25;
                            },
                            vLineWidth: function (i, node) {
                                return 0.25;
                            },
                            fillColor: function (rowIndex, node, columnIndex) {
                                return (rowIndex === 0) ? '#CCCCCC' : null
                            // 	return (rowIndex % 2 === 0) ? '#CCCCCC' : null;
                            }
                        },
                    },
                ],
            },
        ];
    };

    // Data
    let data2 = {};
    let ol_arr = [];
    if(dataReport && dataReport.length >0 ){
        for (let i = 0; i < dataReport.length; i++) {
            //columus
            ol_arr.push({
                table: {
                    headerRows: 1,
                    widths: ["5%", "35%", "10%", "10%", "10%", "10%", "10%", "10%"],
                    body: [
                        [
                            {
                                text: dataReport[i].col1,
                                style: { fontSize: 12 },
                            },
                            {
                                text: dataReport[i].col2,
                                style: { fontSize: 12 },
                            },
                            {
                                text: dataReport[i].col3,
                                style: { fontSize: 12 },
                            },
                            {
                                text: dataReport[i].col4,
                                style: { fontSize: 12 },
                            },
                            {
                                text: dataReport[i].col5,
                                style: { fontSize: 12 },
                            },
                            {
                                text: dataReport[i].col6,
                                style: { fontSize: 12 },
                            },
                            {
                                text: dataReport[i].col7,
                                style: { fontSize: 12 },
                            },
                            {
                                text: dataReport[i].col8,
                                style: { fontSize: 12 },
                            },
                        ],
                    ],
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 0.25;
                    },
                    vLineWidth: function (i, node) {
                        return 0.25;
                    },
                },
            });

            data2 = ol_arr;
        }
   
        var content = {
            pageOrientation: "landscape",
            pageSize: "A4",
            content: [header(), data2],
            pageMargins: [15, 20, 40, 40],
            defaultStyle: {
                font: "THSarabunNew",
                alignment: "justify",
            },
        };

        generatePdf(true, content, (dataUrl) => {
            setDialogPDF({ open: false, pdfURL: dataUrl });
            // setLoading(false);
        }); 

    }else {
        alert("เกิดข้อผิดพลาด : ไม่พบข้อมูลส่งออก")
        // showMessages(toast,'warn', `เกิดข้อผิดพลาด`, 'ไม่พบข้อมูลส่งออก');
    }
}

export const excelRPT218 = ({dataReport,setLoading,toast}) => {
    // setLoading(true)
    let setBorder = {
        "left": {
            "style": "thin",
            "color": {
                "auto": 1
            }
        },
        "right": {
            "style": "thin",
            "color": {
                "auto": 1
            }
        },
        "top": {
            "style": "thin",
            "color": {
                "auto": 1
            }
        },
        "bottom": {
            "style": "thin",
            "color": {
                "auto": 1
            }
        }
    };
    let styleTextHeaders = {
        fill: {
            fgColor: { rgb: "ffffff" }
        },
        font: { bold: true },
        alignment: {
            horizontal: "center", vertical: "center", wrapText: true
        },
        border: setBorder,

    };
    let styleHeaders = {
        fill: {
            fgColor: { rgb: "c7c7c7" }
        },
        font: { bold: true },
        alignment: {
            horizontal: "center", vertical: "center", wrapText: true
        },
        border: setBorder,
    };

    let styleBorderB = {
        fill: {
            fgColor: { rgb: "ffffff" }
        },
        border: setBorder,
        alignment: {
            vertical: "center", wrapText: true
        },
    };
    
    // const { readData } = this.props;
    // dataReport

    if (dataReport && dataReport.length > 0) {
        let dataRow = dataReport
        let dataExcel = []
        let headerText = [{
            "text": "รายงานการเบิกวัสดุ/อุปกรณ์" + "\n" + formatDateTH_full2(new Date) + " ถึง " + formatDateTH_full2(new Date),
            "style": styleTextHeaders
        },
        {}
        ]

        //หัวรายงาน
        for (let i = 0; i < headerText.length; i++) {            
            dataExcel.push([{ value: headerText[i].text, style: headerText[i].style }])
        }

        // ADD Headers
        dataExcel.push([
            { value: "ที่", style: styleHeaders },
            { value: "รายการ", style: styleHeaders },
            { value: "หน่วย", style: styleHeaders },
            { value: "ราคาต่อหน่วย", style: styleHeaders },
            { value: "สัญญา", style: styleHeaders },
            { value: "จอง", style: styleHeaders },
            { value: "เบิก", style: styleHeaders },
            { value: "ค้างคืน", style: styleHeaders }
        ])

        // ADD Row
        for (let i = 0; i < dataRow.length; i++) {
            //dataExcel
            dataExcel.push([
                { value: dataRow[i].col1 ? dataRow[i].col1 : '', style: styleBorderB },
                { value: dataRow[i].col2 ? dataRow[i].col2 : '', style: styleBorderB },
                { value: dataRow[i].col3 ? dataRow[i].col3 : '', style: styleBorderB },
                { value: dataRow[i].col4 ? dataRow[i].col4 : '', style: styleBorderB },
                { value: dataRow[i].col5 ? dataRow[i].col5 : '', style: styleBorderB },
                { value: dataRow[i].col6 ? dataRow[i].col6 : '', style: styleBorderB },
                { value: dataRow[i].col7 ? dataRow[i].col7 : '', style: styleBorderB },
                { value: dataRow[i].col8 ? dataRow[i].col8 : '', style: styleBorderB }
            ])
        }
        //"xlsx"  "csv"
        exportFile(dataExcel)
        // this.handleCloseExport()
    } else {
        alert("เกิดข้อผิดพลาด : ไม่พบข้อมูลส่งออก")
        // showMessages(toast,'warn', `เกิดข้อผิดพลาด`, 'ไม่พบข้อมูลส่งออก');
    }
}

const exportFile = (dataExcel,setLoading) => {
    
    let filename = "RPT218_" + dateFormat(new Date(), 'yyyymmdd')
    const wb = {
        SheetNames: [filename],
        Sheets: {
            [filename]: excelSheetFromDataSet([{
                columns: null,
                data: dataExcel,
                merges: [{ s: { r: 0, c: 0 }, e: { r: 1, c: 7 } }],
                page: "RPT03"
            }])
        }
    };
    const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    let data = (new Blob([strToArrBuffer(wbout)], { type: "application/octet-stream" }));
    FileSaver.saveAs(data, filename + "." + 'xlsx');
    // setLoading(false)
}

